import styled from 'styled-components';

const Container1 = styled.div`
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  row-gap: 16px;
`;
const GreyBox = styled.div`
  height: ${(props) => props.h}px;
  width: ${(props) => props.h}px;
  background-color: #f0f0f0;
  border-radius: ${(props) => props.br * 4}px;
  min-width: 160px;
  margin-bottom: 16px;
`;

const Container2 = styled.div`
  // border: 1px solid #f0f0f0;
  border-radius: 12px;
  height: 300px;
  padding: 16px;
  margin-bottom: 16px;
  box-shadow: 0px 0px 10px rgb(0 0 0 / 5%);
`;

function ConsultationStartLoader({ n = 6 }) {
  const numberOfCareCards = n;
  const boxes = Array.from({ length: numberOfCareCards }, (_, index) => (
    <GreyBox h={160} w={160} br={3} style={{ width: '48%' }} />
  ));
  return (
    <div
      className="w-[100%] flex flex-col  overflow-auto"
      style={{ height: 'fit-content' }}
    >
      <div className="py-4 px-1">
        <GreyBox h={100} w={160} br={3} style={{ width: '100%' }} />
        <GreyBox h={20} w={160} br={1} style={{ width: '30%' }} />
        <Container2>
          <GreyBox h={20} w={160} br={3} style={{ width: '100%' }} />
          <GreyBox h={20} w={160} br={3} style={{ width: '40%' }} />
          <GreyBox h={20} w={160} br={3} style={{ width: '100%' }} />
          <GreyBox h={20} w={160} br={3} style={{ width: '40%' }} />
        </Container2>
        <Container2>
          <GreyBox h={20} w={160} br={3} style={{ width: '100%' }} />
          <GreyBox h={20} w={160} br={3} style={{ width: '40%' }} />
          <GreyBox h={20} w={160} br={3} style={{ width: '100%' }} />
          <GreyBox h={20} w={160} br={3} style={{ width: '40%' }} />
        </Container2>
      </div>
    </div>
  );
}

export default ConsultationStartLoader;
